import React from 'react'
import PropTypes from 'prop-types'

// Shared Styled Elements
import { Wrapper, Label } from '../SharedStyles.element'

// Styled Elements
import { TextFieldInput } from './TextField.elements'

function TextField(props) {
  // Destructure
  const { id, type, label, disabled, ...rest } = props

  return (
    <Wrapper label={label}>
      {label && <Label disabled={disabled}>{label}</Label>}
      <TextFieldInput disabled={disabled} id={id} type={type} {...rest} />
    </Wrapper>
  )
}

// Default Props
TextField.defaultProps = {
  id: '',
  type: '',
  label: '',
  disabled: false,
}

// Proptypes Validation
TextField.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
}

export default TextField
